'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var simpleDDPLogin = exports.simpleDDPLogin = {
  init: function init() {
    var _this = this;

    this.userId = undefined;
    this._loggedIn = false;

    this.login = function (obj) {
      var atStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return new Promise(function (resolve, reject) {
        _this.apply('login', [obj], atStart).then(function (m) {
          if (m && m.id) {
            _this.userId = m.id;
            _this.token = m.token;
            _this._loggedIn = true;
            if (m.type == 'resume') {
              _this.ddpConnection.emit('loginResume', m);
            } else {
              _this.ddpConnection.emit('login', m);
            }
            resolve(m);
          } else {
            reject(m);
          }
        }, reject);
      });
    };

    this.logout = function () {
      return new Promise(function (resolve, reject) {
        if (_this._loggedIn) {
          _this.apply('logout').then(function (m) {
            _this.userId = undefined;
            _this.token = undefined;
            _this._loggedIn = false;
            _this.ddpConnection.emit('logout');
            resolve();
          }, reject);
        } else {
          resolve();
        }
      });
    };

    this.logoutWhenDisconnectedEvent = this.on('disconnected', function (m) {
      if (_this.userId) {
        _this.ddpConnection.emit('loginSessionLost', _this.userId);
        _this.ddpConnection.pauseQueue();
      }

      _this._loggedIn = false;
    });

    this.clientReadyEvent = this.on('clientReady', function () {
      if (_this.userId) {
        _this.login({ resume: _this.token }, true).catch(function (m) {
          _this.ddpConnection.emit('loginResumeFailed', m);
        });
        _this.ddpConnection.continueQueue();
      }
    });
  }
};